module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "consent-step"
    }
  }, [_c('div', {
    staticClass: "absolute pin-t pin-r py-6 px-4 cursor-pointer",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "src": require("../assets/img/close-white.svg")
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex p-6 md:pt-0 border-t md:border-none"
  }, [_c('csf-button', {
    staticClass: "mr-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("I agree")]), _vm._v(" "), _c('csf-button', {
    staticClass: "mr-4",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Back")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-base text-white p-4 md:p-6 md:text-lg"
  }, [_c('p', {
    staticClass: "heading first"
  }, [_vm._v("Your task")]), _vm._v(" "), _c('p', [_vm._v("Upload an image that best reflects your experience of nature or society in your local area.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e89fe95e","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/ConsentStep.vue
// module id = 176
// module chunks = 0